// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=js"
// @generated from file vitesse/v1/controller.proto (package vitesse.v1, syntax proto3)
/* eslint-disable */
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_vitesse_v1_entitlements } from "./entitlements_pb.js";
import { file_vitesse_v1_log } from "./log_pb.js";
/**
 * Describes the file vitesse/v1/controller.proto.
 */
export const file_vitesse_v1_controller = /*@__PURE__*/ fileDesc("Cht2aXRlc3NlL3YxL2NvbnRyb2xsZXIucHJvdG8SCnZpdGVzc2UudjEiowIKFENvbnRyb2xsZXJEZXNjcmlwdG9yEhQKDGRpc3BsYXlfbmFtZRgBIAEoCRIOCgZkcml2ZXIYAiABKAkSDwoHYWRkcmVzcxgDIAEoCRINCgVtb2RlbBgEIAEoCRIQCghmaXJtd2FyZRgFIAEoCRIOCgZzdGF0dXMYBiABKAkSFAoMZXJyb3JfZGV0YWlsGAcgASgJEhoKEmNvbm5lY3RlZF9zaW5jZV9ucxgIIAEoAxIUCgxzeW1ib2xfY291bnQYCSABKAQSGAoQZGlzY292ZXJ5X3N0YXR1cxgKIAEoCRIuCgpwcm9wZXJ0aWVzGAsgASgLMhoudml0ZXNzZS52MS5Qcm9wZXJ0aWVzVmlldxIRCglwbHVnaW5faWQYDCABKAkiOwoOUHJvcGVydGllc1ZpZXcSKQoGdGFibGVzGAEgAygLMhkudml0ZXNzZS52MS5Qcm9wZXJ0eVRhYmxlIlYKDVByb3BlcnR5VGFibGUSDQoFdGl0bGUYASABKAkSDwoHY29sdW1ucxgCIAMoCRIlCgRyb3dzGAMgAygLMhcudml0ZXNzZS52MS5Qcm9wZXJ0eVJvdyIcCgtQcm9wZXJ0eVJvdxINCgVjZWxscxgBIAMoCSIdChtDb250cm9sbGVyc1N1YnNjcmliZVJlcXVlc3Qi6wEKD0NvbnRyb2xsZXJFdmVudBIVCg1jb250cm9sbGVyX2lkGAEgASgJEhAKCHJldmlzaW9uGAIgASgEEioKAm9wGAMgASgOMh4udml0ZXNzZS52MS5Db250cm9sbGVyRXZlbnQuT3ASNAoKZGVzY3JpcHRvchgEIAEoCzIgLnZpdGVzc2UudjEuQ29udHJvbGxlckRlc2NyaXB0b3IiTQoCT3ASEgoOT1BfVU5TUEVDSUZJRUQQABIKCgZPUF9QVVQQARINCglPUF9ERUxFVEUQAhIYChRPUF9TTkFQU0hPVF9DT01QTEVURRADIi8KFkNvbnRyb2xsZXJzTG9nc1JlcXVlc3QSFQoNY29udHJvbGxlcl9pZBgBIAEoCTLJAQoLQ29udHJvbGxlcnMSXQoJU3Vic2NyaWJlEicudml0ZXNzZS52MS5Db250cm9sbGVyc1N1YnNjcmliZVJlcXVlc3QaGy52aXRlc3NlLnYxLkNvbnRyb2xsZXJFdmVudCIIirUYBBALQBYwARJbCg1TdWJzY3JpYmVMb2dzEiIudml0ZXNzZS52MS5Db250cm9sbGVyc0xvZ3NSZXF1ZXN0GhQudml0ZXNzZS52MS5Mb2dFdmVudCIOirUYChAGGgRmdWxsQBYwAUK0AQoOY29tLnZpdGVzc2UudjFCD0NvbnRyb2xsZXJQcm90b1ABWkhnaXRodWIuY29tL01vdmVuZGktYWkvdml0ZXNzZS1wbGF0Zm9ybS9wcm90by9nZW4vZ28vdml0ZXNzZS92MTt2aXRlc3NldjGiAgNWWFiqAgpWaXRlc3NlLlYxygIKVml0ZXNzZVxWMeICFlZpdGVzc2VcVjFcR1BCTWV0YWRhdGHqAgtWaXRlc3NlOjpWMWIGcHJvdG8z", [file_vitesse_v1_entitlements, file_vitesse_v1_log]);
/**
 * Describes the message vitesse.v1.ControllerDescriptor.
 * Use `create(ControllerDescriptorSchema)` to create a new message.
 */
export const ControllerDescriptorSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_controller, 0);
/**
 * Describes the message vitesse.v1.PropertiesView.
 * Use `create(PropertiesViewSchema)` to create a new message.
 */
export const PropertiesViewSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_controller, 1);
/**
 * Describes the message vitesse.v1.PropertyTable.
 * Use `create(PropertyTableSchema)` to create a new message.
 */
export const PropertyTableSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_controller, 2);
/**
 * Describes the message vitesse.v1.PropertyRow.
 * Use `create(PropertyRowSchema)` to create a new message.
 */
export const PropertyRowSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_controller, 3);
/**
 * Describes the message vitesse.v1.ControllersSubscribeRequest.
 * Use `create(ControllersSubscribeRequestSchema)` to create a new message.
 */
export const ControllersSubscribeRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_controller, 4);
/**
 * Describes the message vitesse.v1.ControllerEvent.
 * Use `create(ControllerEventSchema)` to create a new message.
 */
export const ControllerEventSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_controller, 5);
/**
 * Operation type. Same shape as ValueEvent.Op.
 *
 * @generated from enum vitesse.v1.ControllerEvent.Op
 */
export var ControllerEvent_Op;
(function (ControllerEvent_Op) {
    /**
     * @generated from enum value: OP_UNSPECIFIED = 0;
     */
    ControllerEvent_Op[ControllerEvent_Op["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * descriptor present in `descriptor`
     *
     * @generated from enum value: OP_PUT = 1;
     */
    ControllerEvent_Op[ControllerEvent_Op["PUT"] = 1] = "PUT";
    /**
     * controller removed; `descriptor` unset
     *
     * @generated from enum value: OP_DELETE = 2;
     */
    ControllerEvent_Op[ControllerEvent_Op["DELETE"] = 2] = "DELETE";
    /**
     * The snapshot phase is over; everything after this is a live delta.
     * Carries no controller — `controller_id` and `descriptor` are unset.
     *
     * It exists because "the snapshot arrived" was previously inferred from
     * receiving at least one OP_PUT, which is unsound for the empty set: a
     * gateway with no controllers yet — a brand-new box, or one whose PLCs are
     * not cabled — sent nothing at all, so a healthy gateway was
     * indistinguishable from an unreachable one and the UI showed "Connecting"
     * forever. An empty snapshot is a normal answer, and a protocol has to be
     * able to say it.
     *
     * ALWAYS sent, empty snapshot or not, so the boundary is a fact rather than
     * a heuristic. Additive: a client that does not know this op sees an event
     * with no descriptor and ignores it, exactly as before.
     *
     * @generated from enum value: OP_SNAPSHOT_COMPLETE = 3;
     */
    ControllerEvent_Op[ControllerEvent_Op["SNAPSHOT_COMPLETE"] = 3] = "SNAPSHOT_COMPLETE";
})(ControllerEvent_Op || (ControllerEvent_Op = {}));
/**
 * Describes the enum vitesse.v1.ControllerEvent.Op.
 */
export const ControllerEvent_OpSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_controller, 5, 0);
/**
 * Describes the message vitesse.v1.ControllersLogsRequest.
 * Use `create(ControllersLogsRequestSchema)` to create a new message.
 */
export const ControllersLogsRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_controller, 6);
/**
 * @generated from service vitesse.v1.Controllers
 */
export const Controllers = /*@__PURE__*/ serviceDesc(file_vitesse_v1_controller, 0);
//# sourceMappingURL=controller_pb.js.map